import { useTranslation } from 'react-i18next';

const partners = [
  { name: '2M Kablo', logo: 'https://can-el.com/common/img/markalar/2mkablo.jpg' },
  { name: 'ABB', logo: 'https://can-el.com/common/img/markalar/abb.jpg' },
  { name: 'Amper', logo: 'https://can-el.com/common/img/markalar/amper.jpg' },
  { name: 'Best', logo: 'https://can-el.com/common/img/markalar/best.jpg' },
  { name: 'EAE', logo: 'https://can-el.com/common/img/markalar/eae.jpg' },
  { name: 'EEC', logo: 'https://can-el.com/common/img/markalar/eec.jpg' },
  { name: 'Eltaş', logo: 'https://can-el.com/common/img/markalar/eltas.jpg' },
  { name: 'Erse', logo: 'https://can-el.com/common/img/markalar/erse.jpg' },
  { name: 'FG Wilson', logo: 'https://can-el.com/common/img/markalar/fgwilson.jpg' },
  { name: 'Honeywell', logo: 'https://can-el.com/common/img/markalar/honeywell.jpg' },
  { name: 'Legrand', logo: 'https://can-el.com/common/img/markalar/legrand.jpg' },
  { name: 'LG', logo: 'https://can-el.com/common/img/markalar/lg.jpg' },
  { name: 'Litpa', logo: 'https://can-el.com/common/img/markalar/litpa.jpg' },
  { name: 'Makel', logo: 'https://can-el.com/common/img/markalar/makel.jpg' },
  { name: 'Mutlusan', logo: 'https://can-el.com/common/img/markalar/mutlusan.jpg' },
  { name: 'Nexans', logo: 'https://can-el.com/common/img/markalar/nexans.jpg' },
  { name: 'Okay Isı Su', logo: 'https://can-el.com/common/img/markalar/okayisu.jpg' },
  { name: 'Osram', logo: 'https://can-el.com/common/img/markalar/osram.jpg' },
  { name: 'Prysmian', logo: 'https://can-el.com/common/img/markalar/prysmian.jpg' },
  { name: 'Schneider Electric', logo: 'https://can-el.com/common/img/markalar/schneider.jpg' },
  { name: 'Siemens', logo: 'https://can-el.com/common/img/markalar/siemens.jpg' },
];

// Sonsuz kayan efekt için listeyi 4 kez tekrarlıyoruz
const loopedPartners = [...partners, ...partners, ...partners, ...partners];

export default function Partners() {
  const { t } = useTranslation();

  return (
    <section className="pt-8 pb-16 bg-white overflow-hidden">
      <style>{`
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 55s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-6 mb-10 text-center">
        <span className="text-[#E8A020] text-xs font-bold tracking-widest uppercase">{t('partners_title')}</span>
      </div>

      {/* Kayan logo şeridi */}
      <div className="relative w-full">
        {/* Sol fade */}
        <div className="absolute left-0 top-0 h-full w-24 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, white 0%, transparent 100%)' }} />
        {/* Sağ fade */}
        <div className="absolute right-0 top-0 h-full w-24 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, white 0%, transparent 100%)' }} />

        <div className="marquee-track">
          {loopedPartners.map((partner, idx) => (
            <div
              key={`${partner.name}-${idx}`}
              className="flex items-center justify-center mx-8 flex-shrink-0"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                style={{ width: '100px', height: 'auto' }}
                className="object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
